<template>
	<Card>
		<Row :getter="16">
			<Col :span="24">
				<div class="global-tool-bar">
				    <div class="left-bar">
				        <span class="title">个人通知管理</span>
				    </div>
				    <div class="right-bar">
				        <Button size="small"
				            class="btns"
				            shape="circle"
				            type="success"
				            icon="ios-add-circle-outline"
				            @click="onPersonalNoticeCreate">新增</Button>
				    </div>
				</div>
			</Col>
		</Row>
		<Modal v-model="personalNoticeFormShow"
		    title="个人通知" :scrollable='true'>

		    <Form label-position="top">
		        <Row>
		            <FormItem label="标题">
		                <Input v-model="personalNoticeForm.title" :maxlength="100"></Input>
		            </FormItem>
		        </Row>
				<Row>
				    <FormItem label="接收人">
				        <Select v-model="personalNoticeForm.receiveUser" filterable>
							<Option v-for="item in userList"
								:key="item.userExternalCustomerLoginUuid"
								:value="item.userExternalCustomerLoginUuid">{{ item.userExternalCustomerName}}</Option>
				        </Select>
				    </FormItem>
				</Row>
		        <Row >
		            <FormItem class="content-top" label="内容">
						<quill-editor v-model="personalNoticeForm.content"></quill-editor>
		            </FormItem>
		        </Row>
		    </Form>
		    <div slot="footer">
		        <Button type="success"
		            class="form-button"
		            @click="onSave">保存</Button>
		        <Button type="text"
		            class="form-button"
		            @click="onCancel">取消</Button>
		    </div>
		</Modal>

		<Row :gutter="16">
		    <Col span="24">
		    <stand-pagination-table :columns="mainTable.columns"
		        :data="mainTable.data"
		        :loading="mainTable.loading"
		        :table-search="mainTable.tableSearch"
		        :table-load-event="getPersonalNoticeTableRecords" />
		    </Col>
		</Row>
	</Card>
</template>

<script>
import search from '@/libs/search';
import StandPaginationTable from '@/components/standard-pagination-table/StandPaginationTable';
import { FORM_EDIT_MODE_CREATE, FORM_EDIT_MODE_MODIFY } from '@/view/mixins/form-edit-mode';
import { getMsgList, saveMsg } from '@/api/modules/system-management/personalnotice-management';
import { dateTimeRender, dateRender } from '@/libs/tableRowTimeRender';
import { getAllUserList } from '@/api/modules/system-management/seedFarm-management';

import 'quill/dist/quill.core.css';
import 'quill/dist/quill.snow.css';
import 'quill/dist/quill.bubble.css';

import { quillEditor } from 'vue-quill-editor';
export default {
    name: 'PersonalNotice',
    components: {
        StandPaginationTable, quillEditor
    },
    data(){
        return{
            personalNoticeForm:{
                formEditMode: '',
                id: '',
                title: '',
                receiveUser:'',
                model:'',
                content: ''
            },
            userList:[],
            personalNoticeFormShow: false,
            mainTable:{
                columns:[
                    { title: '行号', type: 'index', width: 80, align: 'center' },
                    { title: '标题', key: 'title', align: 'center' },
                    { title: '接收人', key: 'userPersonName', align: 'center' },
                    { title: '创建时间', key: 'createTime', align: 'center', render: (h, params) => dateTimeRender(h, params.row.createTime) },
                    { title: '修改时间', key: 'modifyTime', align: 'center', render: (h, params) => dateTimeRender(h, params.row.modifyTime) },
                    {
					    title: '操作',
					    key: 'action',
					    align: 'center',
					    render: (h, params) => {
					        return h('div', [
					            h('Button', {
					                props: {
					                    type: 'text',
					                    size: 'small'
					                },
					                style: {},
					                on: {
					                    click: () => {
					                        this.onPersonalNoticeUpdate(params.row);
					                    }
					                }
					            }, '编辑')]);
					    }
                    }
                ],
                data: [],
                sarchCardShow: false,
                loading: false,
                tableSearch: search.getSearchParams()
			 }
        };
    },
    mounted(){
        this.getUserList();
        this.getPersonalNoticeTableRecords();
    },
    methods:{
        getUserList() {
		    getAllUserList().then(res => {
		        if (res.code === 0) {
		            this.userList = res.data.userExternalCustomerList;
		        }
		    });
        },
        getPersonalNoticeTableRecords(reset = false){
            this.mainTable.tableLoading = true;

            if (reset) {
			    search.globalResetSearch(this.mainTable.tableSearch);
            }
            this.mainTable.tableSearch.filters.enable = true;
            getMsgList(this.mainTable.tableSearch).then(res => {
			    if (res.code === 0) {
			        this.mainTable.data = res.data.records;
			        search.globalSetFilterRecordCount(this.mainTable.tableSearch, res.data.filterRecordCount);
			    }

			    this.mainTable.tableLoading = false;
            }).catch(() => {
			    this.mainTable.tableLoading = false;
            });
			
        },
        onPersonalNoticeCreate(){
            this.personalNoticeForm.formEditMode = FORM_EDIT_MODE_CREATE;
            this.personalNoticeForm.id = '';
            this.personalNoticeForm.title = '';
            this.personalNoticeForm.receiveUser = '';
            this.personalNoticeForm.content = '';
            this.personalNoticeFormShow = true;
        },
        onPersonalNoticeUpdate(row){
            this.personalNoticeForm.formEditMode = FORM_EDIT_MODE_MODIFY;
            this.personalNoticeForm.id = row.id;
            this.personalNoticeForm.title = row.title;
            this.personalNoticeForm.receiveUser = row.userPersonName;
            this.personalNoticeForm.content = row.content;
            this.personalNoticeFormShow = true;
        },
        onSave(){
            const data = Object.assign({}, this.personalNoticeForm);
            saveMsg(data).then(res => {
			    if (res.code === 0) {
			        this.$Modal.success({
			            title: '保存成功',
			            onOk: () => {
			                this.personalNoticeFormShow = false;
			                this.getPersonalNoticeTableRecords();
			            }
			        });
			    }
            });
        },
        onCancel(){
            this.personalNoticeFormShow = false;
        }
    }

};
</script>

<style>
</style>
